<template>
  <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
    <div
      class="head-banner layout-banner fadeUp"
      :class="animate ? 'animate' : ''"
      v-if="itemData"
    >
      <div class="img-box parallaxe">
        <picture>
          <source
            media="(max-width: 767px)"
            :srcset="_.get(itemData, 'media.cover.devices.desktop.mobile')"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="_.get(itemData, 'media.cover.devices.tablet')"
          />
          <img
            :src="_.get(itemData, 'media.cover.devices.desktop')"
            class="img-absolute"
            alt
            v-prlx="{ speed: 0.08 }"
          />
        </picture>
        <div class="gradient"></div>
        <div class="container widget-content">
          <h1 class="main-title white">{{ itemData.title }}</h1>
          <p class="white">{{ itemData.teaser }}</p>
        </div>
      </div>
    </div>
  </intersect>
</template>

<script>
import Vue from "vue";
import AliMixin from "@/mixins/ali";
import Intersect from "vue-intersect";
import Paralax from "@/assets/js/paralax.js";
Vue.directive("prlx", Paralax);

export default {
  mixins: [AliMixin],
  props: {
    itemData: Object,
    require: true,
  },
  components: { Intersect },
  data() {
    return {
      animate: false,

      swiperOptions: {
        speed: 800,
        spaceBetween: 20,
        watchOverflow: true,
        navigation: {
          nextEl: ".productSliderNext",
          prevEl: ".productSliderPrev",
        },
        breakpoints: {
          320: {
            spaceBetween: 10,
            slidesPerView: 1.3,
          },
          768: {
            spaceBetween: 15,
            slidesPerView: 2,
          },
          1024: {
            spaceBetween: 15,
            slidesPerView: 3,
          },
          1366: {
            spaceBetween: 15,
            slidesPerView: 3,
          },
          1440: {
            spaceBetween: 15,
            slidesPerView: 3,
          },
          1680: {
            spaceBetween: 15,
            slidesPerView: 3,
          },
          1900: {
            spaceBetween: 20,
            slidesPerView: 3,
          },
        },
      },
    };
  },
  components: { Intersect },
  // mounted() {
  //   this.startParalaxe();
  // },
};
</script>
